import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import AddressFooter from '../../shared/AddressFooter';

const MembershipCardExpiry = ({ customerName, brandName, brandLogo, onUpdate }) => (
  <div>
    <div className="c-membership-wrapper">
      <div className="c-membership-header">
        <img src={brandLogo} className="c-brand-logo u-mb-8" alt={brandName} />
        <h2 className="c-membership-title">Your credit card is expiring soon!</h2>
      </div>
      <div className="c-membership-text u-mb-8">
        <p>Hey {customerName}!</p>

        <p>Your credit card is set to expire within the next 30 days.</p>

        <p>To continue your membership with {brandName} please update your payment details.
        If you choose not to update your payment details now, you can do so during your next appointment.</p>

        <p>Cheers, <br />
          {brandName}
        </p>
      </div>
      <button className="c-btn c-btn--primary c-membership-btn" onClick={onUpdate}>
      Update Credit Card Details
    </button>
    </div>
    <AddressFooter />
  </div>
);

MembershipCardExpiry.propTypes = {
  customerName: PropTypes.string.isRequired,
  brandName: PropTypes.string.isRequired,
  brandLogo: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      customerName: ownProps.location.query.customerName,
      brandName: ownProps.location.query.brandName,
      brandLogo: ownProps.location.query.brandLogo,
      updateLink: ownProps.location.query.updateLink,
    })
  ),
  withHandlers({
    onUpdate: props => () => {
      props.router.replace(props.updateLink);
    },
  }),
)(MembershipCardExpiry);



// WEBPACK FOOTER //
// ./src/app/notifications/membership/MembershipCardExpiry/index.jsx